<template>
  <div class="chat-input-bar sticky bottom-0 pb-4 pt-2 flex-shrink-0">
    <div
      v-if="uploading || attachError || attachment"
      class="chat-attachment-chip"
      :class="{ 'chat-attachment-chip--error': attachError }"
    >
      <span v-if="uploading">Reading {{ pendingName }}…</span>
      <span v-else-if="attachError">⚠️ {{ attachError }}</span>
      <span v-else>📎 {{ attachment.name }}<template v-if="attachment.truncated"> (truncated)</template></span>
      <button
        v-if="!uploading"
        class="chat-attachment-remove"
        aria-label="Remove attachment"
        @click="clearAttachment"
      >
        ✕
      </button>
    </div>

    <div class="chat-conversation input-pill">
      <span class="cap-avatar">
        <img
          src="@/assets/capacio/login/logo-cropped.svg"
          alt=""
          class="cap-bean"
        >
      </span>
      <button
        class="attach-btn"
        type="button"
        aria-label="Attach a file"
        title="Attach a file (PDF, Word, PowerPoint, Markdown, text, CSV or Excel)"
        :disabled="uploading"
        @click="triggerFilePicker"
      >
        <cai-icon
          name="paperclip"
          :size="16"
        />
      </button>
      <input
        ref="fileInput"
        type="file"
        class="hidden"
        accept=".pdf,.docx,.pptx,.md,.txt,.csv,.xlsx"
        @change="onFileChange"
      >
      <input
        ref="input"
        v-model="draft"
        type="text"
        placeholder="Reply…"
        class="bg-transparent flex-1 outline-none text-gray-700 text-sm"
        @keydown.enter.prevent="submit"
      >
      <button
        class="send-btn"
        aria-label="Send"
        :disabled="uploading"
        @click="submit"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line
            x1="22"
            y1="2"
            x2="11"
            y2="13"
          />
          <polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import CaiIcon from './CaiIcon.vue'
import { uploadChatAttachment } from '../api'

export default {
  components: { CaiIcon },

  data () {
    return {
      draft: '',
      uploading: false,
      pendingName: '',
      attachment: null, // { name, text, truncated } — extracted server-side, this turn only
      attachError: ''
    }
  },

  mounted () {
    if (this.$refs.input) this.$refs.input.focus()
  },

  methods: {
    triggerFilePicker () {
      this.attachError = ''
      this.$refs.fileInput.click()
    },

    async onFileChange (e) {
      const file = e.target.files && e.target.files[0]
      e.target.value = '' // reset so picking the same file again still fires 'change'
      if (!file) return
      this.attachment = null
      this.attachError = ''
      this.uploading = true
      this.pendingName = file.name
      try {
        const { data } = await uploadChatAttachment(file)
        this.attachment = { name: data.filename, text: data.text, truncated: data.truncated }
      } catch (err) {
        this.attachError = (err.response && err.response.data && err.response.data.detail) || 'Could not read this file.'
      } finally {
        this.uploading = false
      }
    },

    clearAttachment () {
      this.attachment = null
      this.attachError = ''
    },

    submit () {
      if (this.uploading) return
      // A bare attachment (no typed question) still needs SOME text for the
      // agent to act on — default to a generic prompt rather than sending "".
      const message = this.draft.trim() || (this.attachment ? 'Please review the attached file.' : '')
      if (!message) return
      this.draft = ''
      const attachment = this.attachment
      this.attachment = null
      this.$emit('send', message, attachment)
    }
  }
}
</script>
